import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }
  return { message: ctx.defaultError }
})

export const sellSchema = z.object({
  aluno: z.object({ id: z.number() }).optional(),
  cliente: z.object({ id: z.number() }).optional(),
  consultor: z.object({
    id: z.union([z.number().int(), z.string()]),
  }),
  idUnidade: z.number().optional(),
  origem: z.string().optional(),
  metodoPagamento: z.string(),
  detalhesCartao: z
    .object({
      id: z.string().optional(),
      tokenCartao: z.string().optional(),
      quantidadeParcelas: z
        .string()
        .transform((value) => Number(value || '0'))
        .optional()
    })
    .optional()
})

export type SellFormSchema = z.infer<typeof sellSchema>
